<template>
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
        <div class="formItemBox">
        <el-form-item label="所属队组:" class="item2 dzBox">
          <el-select   v-model="searchFrom.teamOrgId" filterable placeholder="请选择" clearable   @change="xiaoduiChange">
            <el-option v-for="item in XDList" :label="item.name" :value="item.id" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="司机姓名:">
          <el-input placeholder="" v-model="searchFrom.driverName" ></el-input>
        </el-form-item>
        <el-form-item label="联系电话:">
          <el-input placeholder="" v-model="searchFrom.driverMobile" ></el-input>
        </el-form-item>
        <el-form-item label="创建日期" class="item2" >
          <el-date-picker
              v-model="searchFrom.createTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
                 :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <br>
        <el-form-item label="身份证号:">
          <el-input placeholder="" v-model="searchFrom.driverIdNumber" ></el-input>
        </el-form-item>
        <el-form-item label="车辆号牌:">
          <el-input placeholder="" v-model="searchFrom.vhcNo" ></el-input>
        </el-form-item>
        <el-form-item label="司机状态:">
           <el-select  v-model="searchFrom.driverJobStatus" filterable placeholder="请选择">
             <el-option  label="全部" value="" ></el-option>
              <el-option  label="待作业" value="20" ></el-option>
              <el-option  label="作业中" value="30" ></el-option>
              <el-option  label="已下线" value="10" ></el-option>
              <el-option  label="休假中" value="40" ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="车辆状态:">
           <el-select  v-model="searchFrom.vhcJobStatus" filterable placeholder="请选择">
             <el-option  label="全部" value="" ></el-option>
              <el-option  label="待作业" value="0" ></el-option>
              <el-option  label="作业中" value="1" ></el-option>
            </el-select>
        </el-form-item>

        </div>
        <div style="display: flex;justify-content: space-between;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox">
            <el-button type="primary" v-if="btnFlg[0]" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary"  size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" v-if="btnFlg[1]" @click="addFn" size="mini" >新增</el-button>
            <el-button type="primary" size="mini" @click="exportFn" v-if="btnFlg[2]" :disabled="isDisable">导出</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"  class="tableComent"   bordersize="mini"  @selection-change="selectGoods" @row-click="handleRowClick"
         style="width: 100%" height="100%"  center border>
       <el-table-column type="selection" width="55"></el-table-column>
       <el-table-column  type="index" width="55" label="序号"></el-table-column>
       <el-table-column label="操作" width="100" >
          <template slot-scope="scope">
            <div>
              <el-button v-if="btnFlg[3]" type="text" size="mini"  @click="editFn(scope.row)">修改</el-button>
               <el-button v-if="btnFlg[4]" type="text" size="mini"  @click="delFn(scope.row)">解绑</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="driverName" width="80" label="司机姓名"></el-table-column>
        <el-table-column prop="temporaryFlg" width="80" :show-overflow-tooltip="true" :formatter="emptyFn" label="司机状态">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.driverJobStatus == '10'" >已下线</div>
              <div  v-if="scope.row.driverJobStatus == '20'" style="color:#F73004">待作业</div>
              <div  v-if="scope.row.driverJobStatus == '30'" style="color:#F3BF1C">作业中</div>
              <div  v-if="scope.row.driverJobStatus == '40'" style="color:#8E8E8E">休假中</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="driverMobile" min-width="120" :show-overflow-tooltip="true" label="联系电话"></el-table-column>
        <el-table-column prop="driverIdNumber" min-width="180" :show-overflow-tooltip="true" label="身份证号"></el-table-column>
        <el-table-column prop="vhcNo" min-width="100" label="绑定车辆"></el-table-column>
        <el-table-column prop="temporaryFlg" min-width="80" :show-overflow-tooltip="true" :formatter="emptyFn" label="车辆状态">
          <template slot-scope="scope">
            <div>
              <div v-if="scope.row.vhcJobStatus == '0'" style="color:#5EB408">待作业</div>
              <div  v-if="scope.row.vhcJobStatus == '1'" style="color:#F77706">作业中</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="teamOrgName" width="120" :show-overflow-tooltip="true" :formatter="emptyFn" label="所属队"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUserName" label="创建人" align="center" min-width="100"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateTimeFormat" width="170"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加 -->
    <el-dialog  :title="isAdd?'添加':'修改'" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog"  :visible.sync="addFlag" width="950px" center>
      <div>
        <el-form  :inline="true" :rules="rules"  ref="addForm" :model="addForm"  class="demo-form-inline jiaoyan"  label-width="114px"  size="mini"  >
          <el-form-item label="选择司机:" prop="driverName" >
            <el-select  v-model="addForm.driverName" filterable placeholder="请选择" @change="sijiChange" v-if="isAdd">
              <el-option v-for="item in sijiList" :label="item.driverName" :value="item.driverName" :key="item.id"></el-option>
            </el-select>
            <el-input  placeholder=""  maxlength="50"  v-model="addForm.driverName" :readonly="true" v-else></el-input>
          </el-form-item>
          <el-form-item label="联系电话:" prop="driverMobile" >
            <el-input  placeholder=""  maxlength="50"  v-model="addForm.driverMobile" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="身份证号:" prop="driverIdNumber"  >
            <el-input  placeholder=""  maxlength="50"  v-model="addForm.driverIdNumber" :readonly="true"></el-input>
          </el-form-item>
          <br>
          <el-form-item label="选择车辆:" prop="vhcNo" >
            <el-select  v-model="addForm.vhcNo" filterable placeholder="请选择" >
              <el-option v-for="item in carList" :label="item.vhcNo" :value="item.vhcNo" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="saveFn()">确 定</el-button>
      </span>
    </el-dialog>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, emptyFn, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { getDictionaryDetailList } from '@/api/newTMS'
import { organizationTree, getVehicleDriverListByDh, getDriverListByDh, getVehicleListByDh, cDriverVehicleRelDelete, bindDefaultVehicle, updateDefaultVehicle, getDriverBanciList } from '@/api/vgs-driver2.0'
import uploadImgs from '@/views/newTMS/publicFiles/uploadImgs.vue'
export default {
  components: {
  },
  data () {
    return {
      h: 500,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      HWlist: [],
      loading: false,
      isDisable: false,
      sum: {},
      rules: {
        driverName: [
          { required: true, message: '请选择司机', trigger: 'blur' }
        ],
        vhcNo: [
          { required: true, message: '请选择车辆', trigger: 'blur' }
        ]

      },
      isAdd: false,
      addFlag: false,
      addForm: { },
      XDList: [],
      XZList: [],
      sijiList: [],
      carList: [],
      banciList: [],
      btnFlg: [],
      btnIdArr: ['00IM0G0100', '00IM0G0200', '00IM0G0300', '00IM0G0400', '00IM0G0500']

    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    this.searchFn()
    organizationTree({ flag: 1 }).then((res) => {
      this.XDList = res
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 168) + 'px'
  },
  methods: {
    async exportFn (val) {
      if (this.searchFrom.createTime) {
        this.searchFrom.createTimeStart = this.searchFrom.createTime[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTime[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      this.isDisable = true
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      form.header = val
      await exportExcel(
        this.global.driverNameT + '/cDriverVehicleRel/exportVehicleDriverListByDh',
        form,
        '人车绑定'
      )
      this.isDisable = false
    },
    // 线次模式更改
    banciChange (e) {
      getDriverBanciList({ banciTypeName: e }).then(res => { this.banciList = res })
      this.$set(this.addForm, 'banciId', null)
      this.$set(this.searchFrom, 'banciId', null)
    },
    sijiChange (e) {
      if (e) {
        let json = this.sijiList.filter(item => item.driverName == e)
        if (json[0].suoshuOrgType == 1) {
          this.$alert('只能绑定队或组的组织下的司机', '系统提示')
          this.$set(this.addForm, 'driverName', null)
        } else {
          this.$set(this.addForm, 'driverIdNumber', json[0].driverIdNumber)
          this.$set(this.addForm, 'driverMobile', json[0].driverMobile)
          this.$set(this.addForm, 'driverId', json[0].driverId)
          getVehicleListByDh({ suoshuOrgId: json[0].suoshuOrgId, trailerFlag: 0 }).then(res => {
            this.carList = res
            this.$set(this.addForm, 'vhcNo', null)
          })
        }
      }
    },
    xiaoduiChange (e) {
      if (e) {
        let json = this.XDList.filter(item => item.id == e)
        this.XZList = json[0].children
        this.$set(this.searchFrom, 'operationOrgId', null)
      }
    },
    // 添加
    addFn () {
      this.isAdd = true
      this.addFlag = true
      this.imgList = []
      getDriverListByDh({ flag: 1 }).then(res => {
        this.sijiList = res
      })
    },
    // 修改
    editFn  (row) {
      this.addForm = { ...row }
      this.addForm.relId = row.id
      this.isAdd = false
      this.addFlag = true
      this.$set(this.addForm, 'linshi', row.temporaryFlg == 1)
      getDriverListByDh({ flag: 1 }).then(res => {
        this.sijiList = res
      })
      getVehicleListByDh({ suoshuOrgId: row.suoshuOrgId, trailerFlag: 0 }).then(res => {
        this.carList = res
      })
    },
    saveFn () {
      let json1 = this.banciList.filter(item => item.id == this.addForm.banciId)
      if (json1.length > 0) {
        this.$set(this.addForm, 'banciName', json1[0].banciName)
      } else {
        this.$set(this.addForm, 'banciId', null)
      }
      this.addForm.temporaryFlg = this.addForm.linshi ? 1 : 0 // 0.否、1.是
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          if (this.isAdd) {
            let json = this.carList.filter(item => item.vhcNo == this.addForm.vhcNo)
            this.$set(this.addForm, 'vhcId', json[0].vhcId)
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            bindDefaultVehicle(this.addForm).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.addFlag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            let json = this.carList.filter(item => item.vhcNo == this.addForm.vhcNo)
            this.$set(this.addForm, 'vhcId', json[0].vhcId)
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            updateDefaultVehicle(this.addForm).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.addFlag = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行解绑操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        cDriverVehicleRelDelete({
          relId: row.id
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      this.weight = 0
      var that = this
      selection.forEach(item => {
        that.weight = (that.weight * 1000 + item.weight * 1000) / 1000
      })
      that.weight = that.weight.toFixed(3)
      this.num = selection.length
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      if (this.searchFrom.createTime) {
        this.searchFrom.createTimeStart = this.searchFrom.createTime[0]
        this.searchFrom.createTimeEnd = this.searchFrom.createTime[1]
      } else {
        this.searchFrom.createTimeStart = ''
        this.searchFrom.createTimeEnd = ''
      }
      this.loading = true
      getVehicleDriverListByDh(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.loading = false
      })
    },
    substringAfterLastChar (str, char) {
      let index = str.indexOf(char)
      // 如果找到了字符
      if (index !== -1) {
        // 截取该位置后面的所有字符
        return str.substring(index + 1)
      } else {
        // 如果没有找到字符，返回空字符串或原字符串，取决于你的需求
        return ''
      }
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        orgType: 1,
        pageNo: 1,
        pageSize: 50
      }
      this.searchFn()
    },
    closeDialog () {
      this.addForm = {
      }
      this.imgLis = []
    }
  },
  watch: {
    addForm: {
      handler (newName, oldName) {
        if (this.addForm.quantity && this.addForm.amount) {
          this.$set(this.addForm, 'unitPrice', toFixed(this.addForm.amount / this.addForm.quantity, 2))
        }
      },
      immediate: true,
      deep: true
    }
  }

}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
.inpBox .el-date-editor{
  width:340px!important;
}
/deep/.el-form{
  width: 100%;
}
.jiaoyan /deep/.el-input__inner{
      width: 180px;
}
.imgBox{
  margin:0;
}

.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin-right: 20px;
  }
}
.width1  /deep/.el-input .el-input__inner {
    width: 480px;
}
.remark  /deep/.el-input .el-input__inner {
    width: 480px;
    height: 80px;
}
 .formItemBox{
    /deep/.el-form-item{
      width: 24%;
    }
  }
</style>
